<template>
  <div class="row py25 between-xs brdr-bottom-1 brdr-cl-secondary">
    <div class="item-image">
      <product-image :image="image" class="product-image" />
    </div>
    <div class="col-xs">
      <div class="row">
        <div class="col-xs-12 col-md-9 pb15 text-left">
          <div class="mb15">
            <div class="h4 weight-400 cl-accent medium">
              {{ $t(product.name) | htmlDecode }}
            </div>
            <div class="error" v-if="product.errors && Object.keys(product.errors).length > 0">
              {{ product.errors | formatProductMessages }}
            </div>
            <div class="h5 cl-tertiary pt5">
              {{ product.sku }}
            </div>
            <custom-options-list :selected-options="product.options"/>
          </div>
          <div>
            <div>
              <span class="h5 cl-secondary">
                {{ $t('Qty') }}
                <span class="weight-700">
                  {{ formatQty(product) }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-md-12 bold mt10 p0 ">
            <div>
              <span class="h4 cl-error" v-if="product.special_price && product.price !== product.final_price">{{ product.price * product.qty | price }} </span>
              <span class="price-original h5" v-if="product.special_price && product.price !== product.final_price">{{ product.final_price * product.qty | price }}</span>
              <span v-if="!product.special_price || product.price === product.final_price" class="h4">{{ product.price * product.qty | price }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script async>
import { Product } from '@vue-storefront/core/modules/checkout/components/Product'
import { onlineHelper } from '@vue-storefront/core/helpers'

const ProductImage = () => import(/* webpackChunkName: "vsf-product-image" */ 'theme/components/core/ProductImage');
const CustomOptionsList = () => import(/* webpackChunkName: "vsf-custom-options-list" */ 'theme/components/core/blocks/Microcart/Product/CustomOptionsList');

export default {
  computed: {
    isOnline () {
      return onlineHelper.isOnline
    },
    image () {
      return {
        loading: this.thumbnail,
        src: this.thumbnail
      }
    }
  },
  mixins: [Product],
  components: {
    ProductImage,
    CustomOptionsList
  },
  methods: {
    formatQty (item) {
      return item.stock.is_qty_decimal ? parseFloat(item.qty.toFixed(2)) : item.qty
    }
  }
}
</script>

<style scoped>
.price-original {
  text-decoration: line-through;
}

.product-image {
  margin-right: 16px;

  &.image {
    mix-blend-mode: multiply;
    vertical-align: top;
    width: 150px;
    padding-bottom: calc(100% - 16px);
  }

  @media only screen and (max-width: 576px) {
    margin-right: 8px;
  }
}

.text-left{
  text-align: left;
}
</style>
